export function Spinner({ small, large, label = "Loading" }: { small?: boolean; large?: boolean; label?: string }) {
  return (
    <span role="status" className={`spinner${large ? " spinner--lg" : ""}`} style={small ? { width: 16, height: 16, borderWidth: 2 } : undefined}>
      <span className="sr-only">{label}</span>
    </span>
  );
}

export function PageSpinner() {
  return (
    <div className="center">
      <Spinner large />
    </div>
  );
}
